var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.09036C8.71321 5.27895 7.47849 5.75723 6.38877 6.49657C4.94984 7.47282 3.82833 8.86041 3.16606 10.4839C2.50379 12.1073 2.33051 13.8937 2.66813 15.6172C3.00576 17.3406 3.83911 18.9237 5.06282 20.1662C6.28653 21.4088 7.84563 22.2549 9.54297 22.5977C11.2403 22.9406 12.9996 22.7646 14.5985 22.0922C16.1973 21.4197 17.5639 20.2809 18.5254 18.8199C19.2535 17.7134 19.7245 16.4597 19.9103 15.1531H12.5C11.1193 15.1531 10 14.0166 10 12.6146V5.09036ZM9.84738 2.5499C11.3843 2.35381 12.5 3.64676 12.5 4.99924V12.6146H20C21.332 12.6146 22.6054 13.7475 22.4122 15.3081C22.1951 17.0627 21.5787 18.749 20.604 20.2302C19.3679 22.1087 17.6109 23.5728 15.5552 24.4374C13.4995 25.302 11.2375 25.5282 9.05524 25.0874C6.87295 24.6467 4.8684 23.5587 3.29505 21.9612C1.72171 20.3636 0.650254 18.3282 0.216171 16.1124C-0.217913 13.8965 0.00487454 11.5997 0.856361 9.51243C1.70785 7.42514 3.14979 5.6411 4.99984 4.38591C6.45858 3.39622 8.11937 2.77038 9.84738 2.5499Z",
    fill: "url(#paint0_linear_1_391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2.46078C13.75 1.11682 14.8657 -0.2018 16.4237 0.0257599C17.2473 0.146041 18.0547 0.37049 18.8268 0.695239C20.0401 1.20552 21.1425 1.95344 22.0711 2.89632C22.9997 3.83919 23.7363 4.95854 24.2388 6.19046C24.5586 6.97448 24.7797 7.79431 24.8981 8.63054C25.1222 10.2126 23.8236 11.3454 22.5 11.3454L15.125 11.3454C14.3656 11.3454 13.75 10.7203 13.75 9.94925V2.46078ZM22.3951 8.80694C22.3014 8.24387 22.1453 7.69196 21.9291 7.16189C21.5522 6.23795 20.9997 5.39843 20.3033 4.69128C19.6069 3.98413 18.7801 3.42318 17.8701 3.04047C17.3481 2.82091 16.8045 2.66248 16.25 2.5673V8.80694L22.3951 8.80694Z",
    fill: "url(#paint1_linear_1_391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_391",
    x1: 0.377292,
    y1: 2.5301,
    x2: 22.9128,
    y2: 3.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_391",
    x1: 13.9379,
    y1: -0.00000269808,
    x2: 25.1631,
    y2: 0.242277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon_overview.1afa9f22d1313cef14de81008f4fffd1.svg";
export { ForwardRef as ReactComponent };